import { SortDirection } from "../../referral-leads/typings";

export enum PaymentStatus {
  PAID = 'PAID',
  UNDER_REVIEW = 'UNDER_REVIEW',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
}

export enum InvoiceStage {
  UPLOAD = 'UPLOAD',
  IN_REVIEW = 'IN_REVIEW',
  PAID = 'PAID',
}

export interface Invoice {
  id: string;
  dateUploaded: string;
  url: string;
  stage: InvoiceStage;
}

export enum CurrencyCodes {
  INR = 'INR',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  AUD = 'AUD',
  CAD = 'CAD',
  JPY = 'JPY',
  CNY = 'CNY',
  CHF = 'CHF',
  SEK = 'SEK',
  NZD = 'NZD',
  ZAR = 'ZAR',
  SGD = 'SGD',
  HKD = 'HKD',
  AED = 'AED',
}

export interface Commission {
  channelPartnerPayoutInvoiceId: string;
  currencyCode: CurrencyCodes;
  date: string;
  key: string | null;
  stage: InvoiceStage;
  totalAmount: number;
}

export interface CommissionPaginationArgs {
  nextDate?: string;
}

export interface GetCommissionsResponse {
  data: Commission[];
  nextRow: {
    nextCurrencyCode: CurrencyCodes;
    nextDate: string;
  }
}

export interface CommissionFilters {
  search?: string;
  sort?: {
    sortBy: SortFields;
    direction: SortDirection;
  };
  dateRange?: {
    startDate: string;
    endDate: string;
  };
  paymentStatus?: PaymentStatus;
}

export enum PayoutCommissionsSortTypes {
  newest_first = 'newest_first',
  oldest_first = 'oldest_first',
  highest_amount = 'highest_amount',
  lowest_amount = 'lowest_amount',
  reset = 'reset',
}

export interface PayoutCommissionsSortType {
  type: PayoutCommissionsSortTypes;
}

export interface PayoutCommissionsSortTermAtomType {
  sortFilter: SortFields;
  direction: SortDirection;
  key: PayoutCommissionsSortTypes;
}

export enum DateRangeOptions {
  LAST_MONTH = 'LAST_MONTH',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  LAST_12_MONTHS = 'LAST_12_MONTHS',
  CURRENT_FINANCIAL_YEAR = 'CURRENT_FINANCIAL_YEAR',
  PREVIOUS_FINANCIAL_YEAR = 'PREVIOUS_FINANCIAL_YEAR',
  CUSTOM_DATE_RANGE = 'CUSTOM_DATE_RANGE',
}

export interface InvoiceWorking {
  id: string;
  date: string;
  orgId: string;
  amount: number;
  planId: string;
  currencyCode: CurrencyCodes;
}

export interface GetInvoiceWorkingResponse {
  data: InvoiceWorking[];
  nextOrg: string;
}

export interface InvoiceWorkingPaginationArgs {
  nextClientId?: string;
  nextClientValue?: string;
  hasMore?: boolean;
  totalCount?: number;
}

export interface UploadInvoiceRequest {
  commissionId: string;
  file: File;
}

export interface UploadInvoiceResponse {
  success: boolean;
  message: string;
  invoiceUrl?: string;
}

export enum SortFields {
  dateCreated = 'dateCreated',
  amount = 'amount',
}
